import type { HelpFile } from '../../types/help'
import { TypeValueDetailTestIds } from '../../../testids/TypeValueDetailTestIds'

export const typeValueDetailHelp: HelpFile = {
  docPage: '/docs/admin/types',
  texts: {
    [TypeValueDetailTestIds.typeValueDetailPage]:
      'Einstellungen, Übersetzungen und typisierte Attribute eines einzelnen Typwerts.',
    [TypeValueDetailTestIds.typeValueDetail]: null,
    [TypeValueDetailTestIds.scopedAttributes]:
      'Auf diesen Typwert beschränkte Attributdefinitionen — nur Entitäten dieses Typs können sie tragen.',
    [TypeValueDetailTestIds.cardTitleSettings]:
      'Grundeinstellungen dieses Typwerts: Anzeigenamen-Vorlage und Aktivzustand.',
    [TypeValueDetailTestIds.cardTitleScopedAttributes]:
      'Auf diesen Typwert beschränkte Attributdefinitionen — nur Entitäten dieses Typs können sie verwenden.',
    [TypeValueDetailTestIds.cardTitleTranslations]:
      'Lokalisierte Bezeichnungen und Beschreibungen dieses Typwerts in allen unterstützten Sprachen.',
    [TypeValueDetailTestIds.inputTemplate]:
      'Anzeigenamen-Vorlage — Mustache-Platzhalter wie {{firstName}} {{lastName}} werden beim Rendern gegen Entitätsattribute aufgelöst.',
    [TypeValueDetailTestIds.btnSaveSettings]: null,
    [TypeValueDetailTestIds.btnEditTranslations]: null,
    [TypeValueDetailTestIds.stalePlaceholderWarning]:
      'Die Vorlage verweist auf Attribut-Platzhalter, die im zugrunde liegenden Typ nicht mehr existieren.',
    [TypeValueDetailTestIds.colLanguage]: null,
    [TypeValueDetailTestIds.colLabel]: null,
    [TypeValueDetailTestIds.colDescription]: null,
    [TypeValueDetailTestIds.colLanguageEdit]: null,
    [TypeValueDetailTestIds.colLabelEdit]: null,
    [TypeValueDetailTestIds.colDescriptionEdit]: null,
  },
}
